import React from "react";
//Iconos de Material UI.
import { IconButton } from '@mui/material';

// BtnActionModal: Componente que renderiza un estilo para los botones de acciones en las ventanas modales.

const BtnActionModal = ({ onClick, children }) => {
    return(
        <IconButton sx={{ backgroundColor: "var(--bg-border-ligth-by-mode)", color: "var(--bg-text-inbox-by-mode)" }}
            onClick={onClick} >
            {children}
        </IconButton>
    )
};

export default BtnActionModal;